module.exports = __webpack_public_path__ + "img/Ticket.1f827ce4.png";